import React from "react";
import { Link } from "react-router-dom";

const PainArea = ({
  library,
  highlightedImageIndex,
  onSelectPainPoint,
  currentPainAreaSelectionCount,
  setSelectedPainPointDetails,
}) => {
  return (
    <div className="yes-after-block-step">
      <h4 class="pain_library_header_title">
        Select the Image that Best Matches Your Pain​
      </h4>
      <div className="yes-after-block-step-inner">
        {library?.map((point, index) => (
          <div key={index} className={`library-img-container-main-inner`}>
            <div
              className={`library-img-container-main common-box-height ${
                highlightedImageIndex === index ? "highlighted" : ""
              }`}
            >
              <Link
                className="nav-link common-box-bg-all library-nav"
                onClick={() => {
                  onSelectPainPoint(
                    index,
                    point.id,
                    currentPainAreaSelectionCount
                  );
                  // saving the details
                  setSelectedPainPointDetails({
                    title: point.title,
                    image: point.image,
                  });
                }}
              >
                <div className="library-img-container">
                  <div className="library-img-box">
                    <img src={point.image} alt={point.title} />
                  </div>
                  <div className="library-img-container-inner">
                    <div className="title-one">{point.title}</div>
                  </div>
                </div>
              </Link>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PainArea;
